import { ContentService } from "../../../services/ContentService";
import { MediaService } from "../../../services/MediaService";
interface ILinkListItem {
  title: string;
  value: string;
}

interface ILinkMenu {
  title: string;
  menu: Array<ILinkListItem | ILinkMenu>;
}

export const editorToolbar = (customToolbarButtons = "") => [
    "cut copy paste",
    "undo redo",
    "styles",
    "fontfamily",
    "forecolor backcolor",
    "bold italic",
    "fontsize",
    "emoticons",
    "alignleft aligncenter alignright alignjustify",
    "numlist bullist",
    "outdent indent",
    "link image media refreshmedia",
    "code",
    "fullscreen",
    customToolbarButtons
  ].filter(Boolean).join(" | ");

export const editorPlugins = "image preview visualblocks table lists code link fullscreen media emoticons";
export const editorFontSizes = "0.50rem 0.75rem 1.00rem 1.25rem 1.50rem 1.75rem 2.00rem 2.25rem 2.50rem 2.75rem 3.00rem 3.25rem 3.50rem 3.75rem 4.00rem 4.25rem 4.50rem 4.75rem 5.00rem";
const buildMenuHierarchy = (pages: any[]): ILinkMenu[] => {
    const root: ILinkMenu[] = [];
  
    pages.forEach((page: any) => {
      const parts: string[] = page.url.split('/').filter((part: string) => part.length > 0); // Split the URL into its parts
      let currentLevel: ILinkMenu[] = root; // Start at the root level
  
      parts.forEach((part: string, index: number) => {
        const isLastPart: boolean = index === parts.length - 1;
  
        // Find an existing menu item at the current level
        let existingMenu: ILinkMenu | undefined = currentLevel.find(
          (item: ILinkMenu) => 'title' in item && item.title === part
        ) as ILinkMenu;
  
        if (!existingMenu) {
          // If the menu doesn't exist, create a new one
          existingMenu = { title: part, menu: [] };
          currentLevel.push(existingMenu);
        }
  
        if (isLastPart) {
          // If it's the last part, it's a link
          (existingMenu.menu as ILinkListItem[]).push({ title: page.text, value: page.url });
        } else {
          // Move deeper into the menu
          currentLevel = existingMenu.menu as ILinkMenu[];
        }
      });
    });
  
    return root;
  };

export const editorPages = async (service: ContentService) => {
 const pages = await service.getPagesTreeData();
 return pages?.length ? buildMenuHierarchy(pages.filter((page: any) => (page.type ?? "").toLowerCase() === "page")) : [];
};
export const editorImages = async (service: MediaService): Promise<Array<any> | null> => {
  
    const res = await service.getMediaTree();
    if (!res || res.length === 0) return null;
  
    const nodeMap = new Map<string, any>();
    const tree: any[] = [];
    const rootNodeId = '#'; // Adjust if your root parent is different
  
    // Step 1: Create nodes
    res.forEach(item => {
      const node: any = {
        title: item.text
      };
  
      if (item.url) {
        node.value = item.url; // It's a file
      } else {
        node.menu = []; // It's a folder
      }
  
      nodeMap.set(item.id, node);
    });
  
    // Step 2: Build hierarchy
    res.forEach(item => {
      const node = nodeMap.get(item.id);
      const parentId = item.parent;
  
      if (!parentId || parentId === rootNodeId || !nodeMap.has(parentId)) {
        tree.push(node);
      } else {
        const parent = nodeMap.get(parentId);
        if (!parent.menu) parent.menu = [];
        parent.menu.push(node);
      }
    });
  
    // Step 3: Recursive sort — folders first, then files, both alphabetically
    const sortTree = (nodes: any[]) => {
      nodes.sort((a, b) => {
        const isAFolder = !!a.menu;
        const isBFolder = !!b.menu;
  
        if (isAFolder && !isBFolder) return -1;
        if (!isAFolder && isBFolder) return 1;
  
        return a.title.localeCompare(b.title);
      });
  
      nodes.forEach(node => {
        if (node.menu && node.menu.length > 0) {
          sortTree(node.menu);
        }
      });
    };
  
    sortTree(tree);
    return tree;
  };
